export const LIST_ALPHA = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export const LIST_NATION = [
  "Kinh",
  "Tày",
  "Thái",
  "Mường ",
  "Khmer",
  "Hoa ",
  "Nùng  ",
  "Mông",
  "Dao",
  "Gia Rai",
  "Ê  Đê",
  "Ba Na",
  "Sán Chay ",
  "Chăm ",
  "Cơ Ho",
  "Xơ Đăng",
  "Sán Dìu",
  "Hrê",
  "RaGlay",
  "Mnông",
  "Thổ",
  "Xtiêng",
  "Khơ mú",
  "Bru Vân Kiều",
  "Cơ Tu",
  "Giáy",
  "Tà Ôi",
  "Mạ",
  "Giẻ-Triêng",
  "Co",
  "Chơ Ro",
  "Xinh Mun",
  "Hà Nhì",
  "Chu Ru",
  "Lào",
  "La Chí",
  "Kháng",
  "Phù Lá",
  "La Hủ",
  "La Ha",
  "Pà Thẻn",
  "Lự",
  "Ngái",
  "Chứt",
  "Lô Lô",
  "Mảng",
  "Cơ Lao",
  "Bố Y",
  "Cống",
  "Si La",
  "Pu Péo",
  "Rơ Măm",
  "Brâu",
  "Ơ Đu",
];
export const COLORS_CHECK = [
  "#999",
  "#21c83d",
  "#efd732",
  "#fd7a23",
  "#db0d18",
];

export const RolesRight = {
  "users": {
    title: "Quản lý tài khoản",
    table: "users",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      upload: { title: "Upload", checked: false },
      export: { title: "Xuất dữ liệu", checked: false },
      roles: { title: "Phân quyền", checked: false },
      login: { title: "Đăng nhập", checked: false },
      viewallpart: { title: "Quản lý theo phòng ban", checked: false },
      viewallcompany: { title: "Quản lý theo công ty", checked: false },
      viewall: { title: "Quản lý tất cả", checked: false },
    },
  },
  "users_login": {
    title: "Theo dõi đăng nhập",
    checked: false,
  },
  "roles": {
    title: "Quản lý quyền hạn",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "du-an": {
    title: "Quản lý dự án",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "chu-dau-tu": {
    title: "Quản lý chủ đầu tư",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "bang-hang": {
    title: "Quản lý bảng hàng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      import: { title: "Import excel", checked: false },
    },
  },
  "pipeline_settings": {
    title: "Cài đặt Pipeline",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "banghang_settings": {
    title: "Cài đặt Bảng hàng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "tags_settings": {
    title: "Quản lý thẻ",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false }
    },
  },
  "khach-hang-cua-toi": {
    title: "Khách hàng của tôi",
    checked: false,
    children: {
      viewall: { title: "Xem tất cả", checked: false },
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
      import: { title: "Import", checked: false },
      takecare: { title: "Chăm sóc", checked: false },
      export: { title: "Export", checked: false },
      assign: { title: "Phân chia", checked: false },
      viewsource: { title: "Xem nguồn", checked: false },
    },
  },
  "khach-hang-da-chot": {
    title: "Quản lý khách hàng đã chốt",
    checked: false,
    children: {
      viewall: { title: "Xem tất cả", checked: false },
    }
  },
  "campaign": {
    title: "Quản lý chiến dịch",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "khach-hang": {
    title: "Quản lý khách hàng",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
  "giao-dich": {
    title: "Quản lý giao dịch",
    checked: false,
    children: {
      add: { title: "Thêm", checked: false },
      edit: { title: "Sửa", checked: false },
      delete: { title: "Xoá", checked: false },
    },
  },
};
